import React from "react"

import { forgotPassword } from "../../../../services/authentication"
import configs from "../../../../configs"

import Form, { Group, Input } from "../../../../components/Form"
import Nav from "../../../../components/Nav"
import Logo from "../../../../components/Logo"
import Button from "../../../../components/Button"

class ForgotPassword extends React.Component {
  constructor(props) {
    super(props)

    this.state = {
      user: {
        email: {
          label: "Email",
          name: "email",
          type: "email",
          value: "",
          required: true,
          class: ""
        }
      },
      isSubmitted: false,
      loading: false,
      successMessage: ""
    }
  }

  onChange = (name, field, value) => {
    const { user } = this.state

    this.setState({
      user: {
        ...user,
        [name]: {
          ...user[name],
          message: "",
          [field]: value
        }
      }
    })
  }

  onSubmit = e => {
    e.preventDefault()

    const { user } = this.state

    this.setState({
      loading: true
    })

    forgotPassword(user).then(
      message => {
        this.setState({
          successMessage: message,
          loading: false
        })
      },
      fields => {
        this.setState({
          isSubmitted: true,
          loading: false,
          user: {
            ...user,
            ...fields
          }
        })
      }
    )
  }

  render() {
    const { user, isSubmitted, successMessage, loading } = this.state

    return (
      <div className="container-fluid">
        <div className="row">
          <div className="col-lg-7 authentication_sidebar">
            <Logo color="white" href="/" title="Resanec" />
            <Logo color="black" href="/" title="Resanec" mobile />

            <div className="authentication_sidebar_container">
              <h1 className="authentication_sidebar_title">
                NDIS Pre-Planning
              </h1>
              <div className="authentication_sidebar_subtitle">
                Online is easy. When done together, it’s better.
              </div>
              <div className="authentication_sidebar_description">
                <ul>
                  <li>Easy collaboration with family, friends</li>
                  <li>Efficient editing and revising capability</li>
                  <li>
                    Dynamic commenting facility to provide input and feedback on
                    pre-plan progress and is
                  </li>
                  <li>ideal if you live in a remote location....and more.</li>
                </ul>
              </div>
            </div>
          </div>

          <div className="col-lg-5 authentication_content authentication_content--dark">
            <Nav
              navigation={configs.authentication.navigation}
              className="nav--right nav--dark"
            />

            <div className="authentication_content_container">
              <h2 className="authentication_content_title">Forgot Password</h2>

              {successMessage ? (
                <div className="authentication_content_description">
                  {successMessage}
                </div>
              ) : (
                <Form onSubmit={this.onSubmit}>
                  <Group>
                    <Input
                      onChange={this.onChange}
                      isSubmitted={isSubmitted}
                      field={user.email}
                    />
                  </Group>

                  <Group className="form_group--padding-top-lg">
                    <Button
                      button={{ type: "submit", disabled: loading }}
                      className="btn--secondary btn--width-full btn--height-md"
                    >
                      Send
                    </Button>
                  </Group>
                </Form>
              )}
            </div>
          </div>
        </div>
      </div>
    )
  }
}

export default ForgotPassword
